import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexBetween,
  FlexRowCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd } from '../General/Table';
import {
  getBackorderRowInfo,
  getInvoiceDetailInfo,
  getOrderRowInfo,
  getRequestRowInfo,
} from '../../../utilities/selectors';
import { SvgIcon, IconType } from '../General/SvgIcon';
import {
  getRequestIcon,
  getRequestColor,
  prop,
  formatPrice,
  getImagePath,
  round,
} from '../../../utilities';

export interface Props {
  backorder: any;
  theme: any;
  downloadFile: any;
  showCSV?: boolean;
}

function BackorderRow({ backorder, theme, downloadFile, showCSV }: Props) {
  const {
    outerId,
    productName,
    userId,
    totalPrice,
    quantity,
    quantityDelivered,
    date,
    payload,
    productData,
    orderData,
  } = getBackorderRowInfo(backorder);
  const color = getRequestColor(status, theme);
  const icon = getRequestIcon(status);

  const handleDownloadFile = () => {
    downloadFile();
  };

  const handleDownloadCsvFile = () => {
    downloadFile('csv');
  };

  const customerOrderNr =
    prop(payload, 'EshopCustomNumber') || prop(payload, 'CustomerNumber');
  const units = prop(payload, 'MeasUnit');
  const productUrl = prop(productData, 'url');
  return (
    <StyledTableRow>
      <StyledTableTd>
        {/* <FlexRowCenter>
          <Image
            src={getImagePath(
              'https://www.zemplin.sk/api/v1',
              prop(productData, 'picture'),
              { width: 64, height: 64 },
            )}
            width={64}
            height={64}
          />
          <FlexCol>
            <CellText>{productName}</CellText>
          </FlexCol>
        </FlexRowCenter> */}
        <FlexRowCenterVertical>
          <StyledImageLink to={productUrl ? `/${productUrl}` : '/'}>
            <ImageWrapper>
              <Image
                width={48}
                height={48}
                alt={`Obrázok produktu`}
                src={
                  prop(productData, 'picture')
                    ? getImagePath(
                        'https://www.zemplin.sk/api/v1',
                        prop(productData, 'picture'),
                        { width: 48, height: 48 },
                      )
                    : '/images/zemplin/placeholder.svg'
                }
              />
            </ImageWrapper>
          </StyledImageLink>
          <FlexCol>
            <StyledLink to={productUrl ? `/${productUrl}` : '/'}>
              <ProductName color={color}>{productName}</ProductName>
            </StyledLink>
            {/* <Link
              to={`/${prop(order, 'product.publish.0.product_url') ||
                prop(order, 'product.url')}`}
            >
              <ProductPlu>{plu}</ProductPlu>{' '}
            </Link> */}
          </FlexCol>
        </FlexRowCenterVertical>
      </StyledTableTd>
      <StyledTableTd>
        <CellText>
          {orderData
            ? customerOrderNr || prop(orderData, 'order_nr')
            : `Mimo eshop (${customerOrderNr || outerId})`}
        </CellText>
      </StyledTableTd>
      <StyledTableTd>
        <CellText>{`${date}`}</CellText>
      </StyledTableTd>
      <StyledTableTd>
        <CellText>{`${round(
          quantity - quantityDelivered,
          4,
        )} ${units}`}</CellText>
      </StyledTableTd>
      <StyledTableTd>
        <CellText>{`${quantity} ${units}`}</CellText>
      </StyledTableTd>
      <StyledTableTd>
        <CellText>{formatPrice(totalPrice, 'EUR')}</CellText>
      </StyledTableTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const DownloadTableTd = styled(StyledTableTd)`
  padding: ${rem(8)} ${rem(16)};
`;

const DownloadText = styled(TextP)`
  color: ${({ theme }) => theme.colors.primary};
`;

const StyledButton = styled.button`
  border: 0;
  background: transparent;
  display: flex;
  flex-flow: row nowrap;
  gap: ${rem(8)};
  align-items: center;
  cursor: pointer;
`;

const DownloadButtonsWrapper = styled(FlexRowCenter)`
  gap: ${rem(8)};
  justify-content: flex-start;
`;

const StatusTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const LinkToRequest = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};

  &:hover {
    text-decoration: underline;
  }
`;

const CellText = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StatusText = styled(CellText)<{ color?: string }>`
  color: ${({ theme, color }) => (color ? color : theme.colors.textPrimary)};
`;

const ProductName = styled(TextP)`
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const ProductPlu = styled(TextP)`
  font-size: ${rem(14)};
  color: #aaaaaa;

  &:hover {
    text-decoration: underline;
  }
`;

const ImageWrapper = styled(FlexCol)`
  flex-shrink: 0;
  margin-right: ${rem(16)};
`;

const Image = styled.img`
  flex-shrink: 0;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const StyledImageLink = styled(StyledLink)`
  flex-shrink: 0;
`;

const WithThemeRow: any = withTheme(BackorderRow);
export { WithThemeRow as BackorderRow };
